import React from 'react'

import { ROUTES } from '../../../../../../../../constants/routes'
import { ContactSearchResult } from '../../../../../../../../types/responses/global-search'
import HighlightableContent from '../../../../../../HighlightableContent'
import SanitizedHtml from '../../../../../../SanitizedHtml'
import { useGlobalSearch } from '../../../../../hooks/useGlobalSearch'
import SearchResultLink from '../../SearchResultLink'

interface Props {
  contact: ContactSearchResult
}

const ContactSearchResultItem: React.FC<Props> = ({ contact }) => {
  const { searchTerm } = useGlobalSearch()

  return (
    <SearchResultLink
      key={contact.id}
      to={ROUTES.editContact({ params: { contactId: contact.id.toString() } })}
    >
      <HighlightableContent
        searchText={searchTerm}
        highlightableItems={{
          name: contact.name,
        }}
      >
        {({ highlightableItems }) => (
          <SanitizedHtml
            as="span"
            className="text-black"
            html={highlightableItems.name}
          />
        )}
      </HighlightableContent>
    </SearchResultLink>
  )
}

export default ContactSearchResultItem
